var map = {
	"./ca.json": [
		"rwei",
		8
	],
	"./en.json": [
		"cCmO",
		9
	],
	"./es.json": [
		"qgB8",
		10
	],
	"./fr.json": [
		"xSkN",
		11
	],
	"./pt.json": [
		"v0ES",
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Zbgq";
module.exports = webpackAsyncContext;